export default __webpack_public_path__ + "static/media/publishing-alt.7963a781.jpg";